import { Pipe, PipeTransform, inject } from "@angular/core";
import { EnumLabelService } from "./services/enum-label/enum-label.service";

@Pipe({
    name: 'fullCountryName',
    standalone: false
})
export class FullCountryNamePipe implements PipeTransform {
    private readonly enumLabels = inject(EnumLabelService);

    /** Name in the active language (shared countries/jurisdictions translations), English list below as fallback. */
    transform(country: string) {
        return this.enumLabels.country(country, this.englishName(country));
    }

    private englishName(country: string) {
        switch (country) {
            case 'AF': return 'Afghanistan';
            case 'AL': return 'Albania';
            case 'DZ': return 'Algeria';
            case 'AD': return 'Andorra';
            case 'AO': return 'Angola';
            case 'AG': return 'Antigua and Barbuda';
            case 'AR': return 'Argentina';
            case 'AM': return 'Armenia';
            case 'AU': return 'Australia';
            case 'AT': return 'Austria';
            case 'AZ': return 'Azerbaijan';
            case 'BS': return 'Bahamas';
            case 'BH': return 'Bahrain';
            case 'BD': return 'Bangladesh';
            case 'BB': return 'Barbados';
            case 'BY': return 'Belarus';
            case 'BE': return 'Belgium';
            case 'BZ': return 'Belize';
            case 'BJ': return 'Benin';
            case 'BT': return 'Bhutan';
            case 'BO': return 'Bolivia';
            case 'BA': return 'Bosnia and Herzegovina';
            case 'BW': return 'Botswana';
            case 'BR': return 'Brazil';
            case 'BN': return 'Brunei';
            case 'BG': return 'Bulgaria';
            case 'BF': return 'Burkina Faso';
            case 'BI': return 'Burundi';
            case 'CV': return 'Cabo Verde';
            case 'KH': return 'Cambodia';
            case 'CM': return 'Cameroon';
            case 'CA': return 'Canada';
            case 'CF': return 'Central African Republic';
            case 'TD': return 'Chad';
            case 'CL': return 'Chile';
            case 'CN': return 'China';
            case 'CO': return 'Colombia';
            case 'KM': return 'Comoros';
            case 'CG': return 'Congo';
            case 'CD': return 'Democratic Republic of the Congo';
            case 'CR': return 'Costa Rica';
            case 'CI': return "Côte d'Ivoire";
            case 'HR': return 'Croatia';
            case 'CU': return 'Cuba';
            case 'CY': return 'Cyprus';
            case 'CZ': return 'Czechia';
            case 'DK': return 'Denmark';
            case 'DJ': return 'Djibouti';
            case 'DM': return 'Dominica';
            case 'DO': return 'Dominican Republic';
            case 'EC': return 'Ecuador';
            case 'EG': return 'Egypt';
            case 'SV': return 'El Salvador';
            case 'GQ': return 'Equatorial Guinea';
            case 'ER': return 'Eritrea';
            case 'EE': return 'Estonia';
            case 'SZ': return 'Eswatini';
            case 'ET': return 'Ethiopia';
            case 'EU': return 'European Union';
            case 'FJ': return 'Fiji';
            case 'FI': return 'Finland';
            case 'FR': return 'France';
            case 'GA': return 'Gabon';
            case 'GM': return 'Gambia';
            case 'GE': return 'Georgia';
            case 'DE': return 'Germany';
            case 'GH': return 'Ghana';
            case 'GR': return 'Greece';
            case 'GD': return 'Grenada';
            case 'GT': return 'Guatemala';
            case 'GN': return 'Guinea';
            case 'GW': return 'Guinea-Bissau';
            case 'GY': return 'Guyana';
            case 'HT': return 'Haiti';
            case 'HN': return 'Honduras';
            case 'HU': return 'Hungary';
            case 'IS': return 'Iceland';
            case 'IN': return 'India';
            case 'ID': return 'Indonesia';
            case 'IR': return 'Iran';
            case 'IQ': return 'Iraq';
            case 'IE': return 'Ireland';
            case 'IL': return 'Israel';
            case 'IT': return 'Italy';
            case 'JM': return 'Jamaica';
            case 'JP': return 'Japan';
            case 'JO': return 'Jordan';
            case 'KZ': return 'Kazakhstan';
            case 'KE': return 'Kenya';
            case 'KI': return 'Kiribati';
            case 'KP': return 'North Korea';
            case 'KR': return 'South Korea';
            case 'KW': return 'Kuwait';
            case 'KG': return 'Kyrgyzstan';
            case 'KY': return 'The Cayman Islands';
            case 'LA': return 'Laos';
            case 'LV': return 'Latvia';
            case 'LB': return 'Lebanon';
            case 'LS': return 'Lesotho';
            case 'LR': return 'Liberia';
            case 'LY': return 'Libya';
            case 'LI': return 'Liechtenstein';
            case 'LT': return 'Lithuania';
            case 'LU': return 'Luxembourg';
            case 'MG': return 'Madagascar';
            case 'MW': return 'Malawi';
            case 'MY': return 'Malaysia';
            case 'MV': return 'Maldives';
            case 'ML': return 'Mali';
            case 'MT': return 'Malta';
            case 'MH': return 'Marshall Islands';
            case 'MR': return 'Mauritania';
            case 'MU': return 'Mauritius';
            case 'MX': return 'Mexico';
            case 'FM': return 'Micronesia';
            case 'MD': return 'Moldova';
            case 'MC': return 'Monaco';
            case 'MN': return 'Mongolia';
            case 'ME': return 'Montenegro';
            case 'MA': return 'Morocco';
            case 'MZ': return 'Mozambique';
            case 'MM': return 'Myanmar';
            case 'NA': return 'Namibia';
            case 'NR': return 'Nauru';
            case 'NP': return 'Nepal';
            case 'NL': return 'Netherlands';
            case 'NZ': return 'New Zealand';
            case 'NI': return 'Nicaragua';
            case 'NE': return 'Niger';
            case 'NG': return 'Nigeria';
            case 'MK': return 'North Macedonia';
            case 'NO': return 'Norway';
            case 'OM': return 'Oman';
            case 'PK': return 'Pakistan';
            case 'PW': return 'Palau';
            case 'PS': return 'Palestine';
            case 'PA': return 'Panama';
            case 'PG': return 'Papua New Guinea';
            case 'PY': return 'Paraguay';
            case 'PE': return 'Peru';
            case 'PH': return 'Philippines';
            case 'PL': return 'Poland';
            case 'PT': return 'Portugal';
            case 'QA': return 'Qatar';
            case 'RO': return 'Romania';
            case 'RU': return 'Russia';
            case 'RW': return 'Rwanda';
            case 'KN': return 'Saint Kitts and Nevis';
            case 'LC': return 'Saint Lucia';
            case 'VC': return 'Saint Vincent and the Grenadines';
            case 'WS': return 'Samoa';
            case 'SM': return 'San Marino';
            case 'ST': return 'Sao Tome and Principe';
            case 'SA': return 'Saudi Arabia';
            case 'SN': return 'Senegal';
            case 'RS': return 'Serbia';
            case 'SC': return 'Seychelles';
            case 'SL': return 'Sierra Leone';
            case 'SG': return 'Singapore';
            case 'SK': return 'Slovakia';
            case 'SI': return 'Slovenia';
            case 'SB': return 'Solomon Islands';
            case 'SO': return 'Somalia';
            case 'ZA': return 'South Africa';
            case 'SS': return 'South Sudan';
            case 'ES': return 'Spain';
            case 'LK': return 'Sri Lanka';
            case 'SD': return 'Sudan';
            case 'SR': return 'Suriname';
            case 'SE': return 'Sweden';
            case 'CH': return 'Switzerland';
            case 'SY': return 'Syria';
            case 'TW': return 'Taiwan';
            case 'TJ': return 'Tajikistan';
            case 'TZ': return 'Tanzania';
            case 'TH': return 'Thailand';
            case 'TL': return 'Timor-Leste';
            case 'TG': return 'Togo';
            case 'TO': return 'Tonga';
            case 'TT': return 'Trinidad and Tobago';
            case 'TN': return 'Tunisia';
            case 'TR': return 'Turkey';
            case 'TM': return 'Turkmenistan';
            case 'TV': return 'Tuvalu';
            case 'UG': return 'Uganda';
            case 'UA': return 'Ukraine';
            case 'AE': return 'United Arab Emirates';
            case 'GB': return 'United Kingdom';
            case 'US': return 'United States';
            case 'UY': return 'Uruguay';
            case 'UZ': return 'Uzbekistan';
            case 'VU': return 'Vanuatu';
            case 'VA': return 'Vatican City';
            case 'VE': return 'Venezuela';
            case 'VN': return 'Vietnam';
            case 'YE': return 'Yemen';
            case 'ZM': return 'Zambia';
            case 'ZW': return 'Zimbabwe';
            default:
                return country;
        }
    }
}